import { Link, Text, View } from '@react-pdf/renderer';
import { FC } from 'react';
import { IntlFormatters } from '@formatjs/intl/src/types';

import { groupingContacts, sortGroupedContacts } from 'lib/contacts';
import { whiteLabelName } from 'lib/whitelabel';
import messages from '../messages';
import { styles } from './styles';

type ResumePdfContactsProps = {
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
};
const primaryColor = whiteLabelName === 'matchy' ? '#4941a0' : '#0097b3';

export const ResumePdfContacts: FC<ResumePdfContactsProps> = ({ profile, formatMessage }) => {
  const groupedContacts = groupingContacts(profile);
  const sortedGroupedContacts = sortGroupedContacts(groupedContacts);
  const left = Object.keys(sortedGroupedContacts).map((key) => {
    const currentKey = key as keyof typeof sortedGroupedContacts;
    const contacts = sortedGroupedContacts[currentKey];
    const iconsMapped = {
      telegram: {
        icon: '\uf2c6',
        styles: styles.iconBrands,
      },
      email: {
        icon: '\uf0e0',
        styles: styles.iconSolid,
      },
      phone: {
        icon: '\uf095',
        styles: styles.iconSolid,
        width: 12,
        height: 12,
      },
      skype: {
        icon: '\uf17e',
        styles: styles.iconBrands,
      },
    };

    return contacts.map((contact, index) => (
      <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        {!index ? (
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Text style={iconsMapped[currentKey].styles}>{iconsMapped[currentKey].icon}</Text>
            <Text style={{ ...styles.text }}>{contact.value}</Text>
          </View>
        ) : (
          <Text style={{ marginLeft: 20, ...styles.text }}>{contact.value}</Text>
        )}
      </View>
    ));
  });
  const rightLinks = (profile.contactsIdByType.get('link') || [])
    .map((_id) => profile.contactsById[_id])
    .map((link) => (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <Link style={{ ...styles.text, color: primaryColor }} src={link.url || ''}>
        {link.domain}
      </Link>
    ));

  return (
    <View style={{ ...styles.section, marginTop: 20 }}>
      <Text style={{ ...styles.subheading, ...styles.bold, marginBottom: 8 }}>
        {formatMessage(messages.contacts)}
      </Text>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          width: '100%',
        }}
      >
        <View
          style={{
            display: 'flex',
            width: '50%',
          }}
        >
          {left}
        </View>
        <View
          style={{
            display: 'flex',
          }}
        >
          {rightLinks}
        </View>
      </View>
    </View>
  );
};
